import moment from 'moment';

const set = (name, data, time) => {
  return new Promise((resolve, reject) => {
    if (document.cookie) {
      document.cookie = `${name}=${btoa(JSON.stringify(data))};expires=${moment().add(time, 'd')._d.toUTCString()};path=/`;
      get(name)
        .then((res) => {
          resolve(res);
        })
        .catch(() => {
          reject(new Error());
        });
    } else {
      reject(new Error());
    }
  });
};
const get = (name) => {
  return new Promise((resolve, reject) => {
    let ary = document.cookie.split(escape(name) + '=');
    if (ary.length >= 2) {
      resolve(JSON.parse(atob(ary[1].split(';')[0])));
    } else {
      reject(new Error());
    }
  });
};
const del = (name) => {
  let date = new Date();
  date.setDate(date.getDate() - 100);
  document.cookie = `${name}=;expires=${date.toUTCString()};path=/`;
};
export default {
  set,
  get,
  del
};



// WEBPACK FOOTER //
// ./src/util/cookies.js